var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardContent, Grid, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { CardFooter, CardWithShadow } from "../components";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { useTranslation } from "react-i18next";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
export var LargeTextCard = function (props) {
    var _a;
    var title = props.title, shortText = props.shortText, createdAt = props.createdAt, onClickSpecialAction = props.onClickSpecialAction, imageUrl = props.imageUrl, to = props.to;
    var PLACEHOLDER = "/images/placeholder300x360.png";
    var _b = useState(1), scale = _b[0], setScale = _b[1];
    var _c = useState("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")")), cleanImageUrl = _c[0], setCleanImageUrl = _c[1];
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    useEffect(function () {
        setCleanImageUrl("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")"));
    }, [imageUrl]);
    return (_jsxs(CardWithShadow, __assign({ sx: { flexDirection: "row", display: "flex", }, onMouseEnter: function () { return setScale(1.08); }, onMouseLeave: function () { return setScale(1); }, onClickSpecialAction: onClickSpecialAction, to: to, fixedWidth: 600 }, { children: [_jsx(Grid, __assign({ item: true, xs: 6, sx: { overflow: "hidden" } }, { children: _jsx(Box, { sx: {
                        height: 360,
                        width: 300,
                        transform: "scale(".concat(scale, ")"),
                        transition: "transform 1.5s",
                        backgroundImage: cleanImageUrl,
                    } }) })), _jsxs(Grid, __assign({ item: true, container: true, sx: { flexDirection: "column", justifyContent: "space-between" }, xs: 6 }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsxs(CardContent, __assign({ sx: { height: "264px" } }, { children: [_jsx(Typography, __assign({ gutterBottom: true, variant: "h4", component: "div", sx: (_a = {},
                                        _a[theme.breakpoints.down("sm")] = isIos && {
                                            '@media (-webkit-min-device-pixel-ratio: 2)': {
                                                fontWeight: 500, // Adjust font weight for iPhones
                                            },
                                        },
                                        _a) }, { children: getLocalizedString(title, currentLang) })), _jsx(Typography, __assign({ gutterBottom: true, variant: "bodyL", component: "div", sx: {
                                        lineHeight: "22px",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 8,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    } }, { children: getLocalizedString(shortText, currentLang) }))] })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(CardFooter, { brightText: false, createdAt: createdAt, shareUrl: to }) }))] }))] })));
};
